<app-user-header class="d-md-none"></app-user-header> 


<div class="wrapperi">
  <div class="p-4">
    <div class="col-12">

      <div class="pointer" (click)="goBack()">
          <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
      </div>
  </div>
  </div>


  <div class="col-12 p-0 row m-0">
    <div class="col-6 p-0">
      <div class="ps-4 pe-2 pt-2">
        <div class="bg-w formed-shadow">
          <div class="p-4">
      
      <div class="p-0">
          <div class="d-flex justify-content-between">
            <div class="">
              <p class="semiboldtextblue24 mb-0 ">{{btnText}}</p>
              <p class="normaltextblue16 "><span *ngIf="userID && userID != currentUserID">Vain käyttäjä itse voi muokata tietojaan<span *ngIf="not_activated"><br>Käyttäjätili odottaa aktivointia</span></span></p>

            </div>
            <div class="align-items-center d-flex justify-content-center mt-3 mb-3" *ngIf="userID">
              <div class="" *ngIf="currentUserID != userID">
                <i data-bs-toggle="modal" data-bs-target="#delete-confirm-modal" class="fa fa-trash-alt me-2"></i>
              </div>
            </div>
          </div>

        <div class="alert alert-warning" *ngIf="messageErr">
          <p class="">Virhe tietoja päivittäessä. Tarkasta tiedot ja että sinulla on valtuudet tehdä muokkauksia.</p>
        </div>
      </div>

      <div id="loader" class="loader-container mt-4"  *ngIf="isLoading">
        <div class="loader mx-auto"></div>
        <p class="text-center pt-3">Pieni hetki...</p>
      </div>

      <div class="">
      <div class="align-items-center" *ngIf="userID && userID == currentUserID; else other_user_image">
        <div class="col-12" >
          <div class="" *ngIf="!user['profilePicture']; else logo_added">
            <div class="d-flex justify-content-center">
              <img class="rounded-circle pe-2 text-center align-self-center mb-4"src="../../assets/icons/formed_no_profile.svg" height="80" alt="">

            </div>
            <div class="text-center">
              <label for="image-file" class="btn btn-formed-main-blue">Lisää kuva</label>

            </div>
            <input style="display:none" (change)="gotFile($event)" type="file" accept="image/png, image/jpeg" id="image-file"/>
      
          </div>
          <ng-template #logo_added>
            <div class="col-12 p-0 mt-4 justify-content-center text-center">
              <div class="col-12 p-0">
                <div class="">
                  <img height="80" class="rounded-circle" src="{{user.profilePicture}}" alt="">

                </div>
              </div>
            </div>
            <div class="text-center justify-content-center w-100 d-flex pb-3">
              <button class="btn btn-formed-hollow mt-4" (click)="removeProfilePicture()">Poista ja vaihda</button>
    
            </div>
          </ng-template>
        </div>
        </div>
        <ng-template #other_user_image>
          <div class="align-items-center d-flex justify-content-center" >
            <div class="col-4 justify-content-center" >
              <div class="" *ngIf="!user['profilePicture']; else logo_added">
                <div class="d-flex justify-content-center">
                  <img class="rounded-circle pe-2 text-center align-self-center mb-4"src="../../assets/icons/formed_no_profile.svg" height="80" alt="">
    
                </div>
          
              </div>
              <ng-template #logo_added>
                <div class="col-12 p-0 mt-4 justify-content-center text-center">
                  <div class="col-12 p-0">
                    <div class="">
                      <img height="80" class="rounded-circle" src="{{user.profilePicture}}" alt="">
    
                    </div>
                  </div>
                </div>

              </ng-template>
            </div>
            </div>
        </ng-template>


      <div  id="form-container justify-content-center" class="" *ngIf="!isLoading">
        <form class="" [formGroup]="form"
        (ngSubmit)="onSubmit()">

        <!-- Etunimi ja sukunimi -->
        <div class="justify-content-center d-flex flex-column align-items-center mt-3">
          

            <div class="form-floating mb-2 col-12 col-md-10 p-0">
                <input  type="text" placeholder="Etunimi" formControlName="firstName" id="firstName" class="form-control" [class.invalid-input]="firstName.errors && firstName.touched" required>
                <label for="firstName">Etunimi</label>
                <div class="my-alerts" *ngIf="firstName.invalid && firstName.touched">
                <p class="mt-2" *ngIf="firstName.errors.required">Etunimi on pakollinen</p>
                <p *ngIf="firstName.errors.firstName"> Vaaditaan kunnollinen etunimi</p>
                </div>
            </div>

            <div class="form-floating mb-2  col-12 col-md-10 p-0">
                <input type="text" placeholder="Sukunimi" formControlName="lastName" id="lastName" class="form-control" [class.invalid-input]="lastName.errors && lastName.touched" required>
                <label class="" for="lastName">Sukunimi</label>
                <div class="my-alerts" *ngIf="lastName.invalid && lastName.touched">
                <p class="mt-2" *ngIf="lastName.errors.required">Sukunimi on pakollinen</p>
                <p *ngIf="lastName.errors.lastName"> Vaaditaan määrätty Sukunimi</p>
                </div>
            </div>
            <div *ngIf="!userID" class="form-floating mb-2  col-12 col-md-10 p-0">
              <input type="email" placeholder="Sähköposti" formControlName="email" id="email" class="form-control" [class.invalid-input]="email.errors && email.touched" required>
              <label class="" for="email">Sähköposti</label>
              <div class="my-alerts" *ngIf="email.invalid && email.touched">
              <p class="mt-2" *ngIf="email.errors.required">Sähköposti on pakollinen</p>
              <p *ngIf="email.errors.email"> Vaaditaan kunnollinen sähköposti</p>
              </div>
          </div>

        </div>
                
            <div class="pt-3">
              
              <div class="form-group mb-2 text-center">
                <span class="" *ngIf="userID && userID == currentUserID">
                  <button [disabled]="form.invalid" class="btn btn-formed-main-blue">{{realbtn}}</button>

                </span>
                <span class="" *ngIf="!userID">
                  <button [disabled]="form.invalid" class="btn btn-formed-main-blue">{{realbtn}}</button>

                </span>
                <span class="" *ngIf="has_expired">
                  <p (click)="renewActivationCode()" class="ms-2 btn btn-formed-main-blue">Uusi aktivointikoodi</p>
                
                </span>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</div>
</div>
    <div class="col-6 h-100">
      <div class="ps-2 pe-2 pt-2 h-100">
        <div class="bg-w formed-shadow h-100">
          <div class="p-4 h-100">
            <p class="semiboldtextblue24">Käyttäjän toimipisteet</p>
            <div class="alert alert-success" *ngIf="saved_subgroups.length == 0">
              <p class="text-left mb-0">
                <span *ngIf="userID && userID != currentUserID">Käyttäjällä näkyvissä kaikkien toimipisteiden työpaikkailmoitukset.</span>
                <span *ngIf="!userID">Palvelussa näet oletuksena kaikkien toimipisteiden työpaikkailmoitukset.
                   Voit kuitenkin rajata, minkä toimipisteiden ilmoitukset haluat nähdä. Tämä helpottaa erityisesti isojen organisaatioiden käyttökokemusta.
                  <br><br>
                  Voit päivittää toimipisteiden listaa milloin tahansa ja hakea myös edelleen 
                  muiden toimipisteiden työpaikkailmoituksia Työpaikat- välilehdeltä.
                </span>
                <span *ngIf="userID == currentUserID">Palvelussa näet oletuksena kaikkien toimipisteiden työpaikkailmoitukset.
                  Voit kuitenkin rajata, minkä toimipisteiden ilmoitukset haluat nähdä. Tämä helpottaa erityisesti isojen organisaatioiden käyttökokemusta.
                 <br><br>
                 Voit päivittää toimipisteiden listaa milloin tahansa ja hakea myös edelleen 
                 muiden toimipisteiden työpaikkailmoituksia Työpaikat- välilehdeltä.
                </span>
              </p>
            
            </div>

            <div class="formed-list bg-f-b pt-3 pb-3" *ngFor="let data of saved_subgroups">
              <div class="col-12 row m-0">
                  <div class="col-12 col-md-9">
                      <div class="col-12 row">
                          <div class="col-12 col-md-12 ps-0 pe-0 ps-md-2 pe-md-2">
                              <div class="d-inline-flex">
                                  <img class="d-none d-md-block"src="../../assets/icons/company_icon_blue.svg" alt="">
                                  <div class="ps-0 ps-md-4">
                                      <p class="normaltextblue80016 mb-0">Nimi</p>
                                      <p class="semiboldtextblue80016 mb-0">{{data.businessName}}</p>
      
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>


            <div class="" *ngIf="!userID || userID == currentUserID">
              <p data-bs-toggle="modal" class="btn btn-formed-main-blue mt-4" data-bs-target="#select-subgroup">Valitse toimipisteet</p>

            </div>

          </div>
        </div>
        <div class="bg-w formed-shadow mt-4 h-100" *ngIf="userID == currentUserID">
          <div class="p-4 h-100">
            <p class="semiboldtextblue24">Ilmoitusasetukset</p>
              <p class="text-left mb-0">Tässä voit muuttaa ilmoitusasetuksiasi. Vakiona kaikki on määritetty aktiiviseksi.</p>
              <div *ngIf="show_notification_success" class="alert alert-success"> 
                <p class="text-center mb-0">Tiedot päivitetty</p>
              </div>
              <div class="" *ngFor="let pref of notification_preferences">
                <div class="col-12 row m-0 pt-3">
                  <div class="col-12 col-md-9">
                    <p class="semiboldtextblue80016 mb-0">{{pref.name}}</p>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [checked]="pref.value" id="notification_{{pref.value}}">
                    </div>
                  </div>
                </div>

              </div>

            <div class="" *ngIf="userID == currentUserID">
              <p class="btn pointer btn-formed-main-blue mt-4" (click)="saveNotificationPreferences()">Tallenna ilmoitusasetukset</p>

            </div>

          </div>
        </div>
    </div>
    </div>
</div>
</div>


        <!-- Modal Check before deleting offer -->
        <button data-bs-toggle="modal" id="delete-confirm" data-bs-target="#delete-confirm-modal" style="display:none"></button>
        <div class="modal fade" id="delete-confirm-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="text-center w-100" id="exampleModalLabel">Käyttäjän poistaminen</h5>
                <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                <button id="close-confirm-modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

                </button>
            </div>
            <div class="modal-body">
                <div class="" *ngIf="!deleteLoader">
                    <p class="text-center">Oletko varma, että haluat poistaa käyttäjän?</p>
                    <div class="text-center justify-content-center d-flex col-12 mt-4 pt-4 ">
                      <button class="btn btn-formed-delete" (click)="removeUser()"><i class="fa fa-trash-alt me-2"></i>Poista käyttäjä</button>
                  </div>

                </div>
                <div id="loader" class="loader-container mt-4" *ngIf="deleteLoader">
                    <div class="loader mx-auto"></div>
                    <p class="text-center pt-3">Tietoja poistetaan...</p>
                  </div>
                



            </div>
            </div>
        </div>
        </div>

                <!-- Modal Check before deleting offer -->
                <button data-bs-toggle="modal" id="crop-image" data-bs-target="#crop-image-modal" style="display:none"></button>
                <div class="modal fade" id="crop-image-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="text-center w-100" id="exampleModalLabel">Rajaa kuva</h5>
                        <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                        <button id="close-confirm-modal2" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        
                        </button>
                    </div>
                    <div class="modal-body">

                      <image-cropper
                      [imageChangedEvent]="imageChangedEvent"
                      [maintainAspectRatio]="true"
                      [aspectRatio]="3 / 3"
                      format="png"
                      (imageCropped)="imageCropped($event)"
                      (imageLoaded)="imageLoaded($event)"
                      (cropperReady)="cropperReady()"
                      (loadImageFailed)="loadImageFailed()"
                  ></image-cropper>

                  <button (click)="saveCroppedImage()" class="btn btn-formed-main-blue mt-4">Tallenna kuva</button>
        
        
        
                    </div>
                    </div>
                </div>
                </div>

                <!-- Modal Check before deleting offer -->
                <button data-bs-toggle="modal" id="crop-image" data-bs-target="#select-subgroup" style="display:none"></button>
                <div class="modal fade" id="select-subgroup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header pb-0">
                        <h5 class="text-center w-100 mt-3" id="exampleModalLabel">Toimipisteet</h5>
                        <!-- <p>Kaikki tähdellä merkityt kentät ovat pakollisia</p> -->
                        <button id="close-confirm-modal2" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        
                        </button>

                    </div>
                    <p class="normaltextblue16 text-center margin-top ps-2 pe-2 pt-2 mb-0">Valitse ne toimipisteet, joiden työpaikkailmoitukset haluat nähdä. Oletuksena näet kaikkien toimipisteiden ilmoitukset.</p>

                    <div class="modal-body ps-4 pe-4 mt-2">

                    
                      <div class="" *ngFor="let data of subGroups">
                        <div class="col-12 row">
                          <div class="col-1">
                            <input type="checkbox" [checked]="data.checked" (change)="saveFavourites(data)" id="subgroups_{{data._id}}">
                          </div>
                          <div class="col-11">
                              <p class="normaltextblue80016">{{data.businessName}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="text-center mt-4">
                        <button class="btn btn-formed-main-blue" data-bs-dismiss="modal" aria-label="Close">Sulje</button>
                      </div>        
                    </div>
                    </div>
                </div>
                </div>